// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.faceted-search-container {
  border-radius: 5px;
  border: 1px solid #A7A9AC;
  margin-bottom: 24px;
  margin-top: 30px;
  padding: 5px 5px 20px 0;
  width: 100%;
}

.form-inline {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
}
.form-inline .keyword-container {
  display: flex;
  width: 875px;
}
.form-inline input[type=text] {
  height: 36px;
  width: 200px;
}
.form-inline .clear-container {
  border-radius: 0 5px 5px 0;
  background-color: #EDf0F1;
  border: 1px solid #D1D3D4;
  contain: content;
  height: 36px;
  padding: 0 5px;
  width: 36px;
}
.form-inline button.keyword-clear {
  margin-top: -10px;
}
.form-inline button.keyword-clear span {
  font-size: 1.8rem;
  margin-left: -5px;
  z-index: 1200;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/FacetedSearch.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AADA;ECAI,kBDCmC;EACnC,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AAIJ;;AAFA;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;AAKJ;AAJI;EACI,aAAA;EACA,YAAA;AAMR;AAJI;EACI,YAAA;EACA,YAAA;AAMR;AAJI;ECrBA,0BDsBuC;EACnC,yBDFA;ECGA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;AAMR;AAJI;EACI,iBAAA;AAMR;AALQ;EACI,iBAAA;EACA,iBAAA;EACA,aAAA;AAOZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
